import {
  NativeSelectProps as MantineNativeSelectProps,
  NativeSelect as MantineNativeSelect,
} from '@mantine/core';

export type NativeSelectProps = MantineNativeSelectProps;

export const NativeSelect = MantineNativeSelect;

NativeSelect.displayName = 'NativeSelect';
